import React from 'react';
import LzFormFieldBase from './_base';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import { lzIsObject } from '../../../../services/LzType';

class LzFormFieldStatic extends React.Component {

    render() {
        const { fluid, alignRight, compact, icon, className, style, label, placeholder, hintText, value, variant } = this.props;

        // console.log('STATIC-VALUE', label, value);
        const styles = style || {};
        if (!styles.paddingTop) {
            styles.paddingTop = 0;
        }
        if (!styles.marginTop) {
            styles.marginTop = 0;
        }
        if (alignRight && !styles.textAlign) {
            styles.textAlign = 'right';
        }

        if ('horizontal' === variant) {
            return (
                <Grid container spacing={0}>
                    <Grid item xs={6}>
                        <InputLabel className="lz-label">
                            {icon && <React.Fragment>{icon} </React.Fragment>}
                            {label}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={6}>
                        {lzIsObject(value) ?
                            <p className={'lz-static ' + (className ? className : '')} style={styles}>{value}</p>
                            :
                            <p className={'lz-static ' + (className ? className : '')} style={styles}
                                dangerouslySetInnerHTML={{ __html: value }}
                            ></p>
                        }
                    </Grid>
                </Grid>
            );
        }

        return (
            <LzFormFieldBase
                labelShrink
                fluid={fluid}
                compact={compact}
                icon={icon}
                label={label}
                placeholder={placeholder}
                hintText={hintText}
            >

                {lzIsObject(value) ?
                    <p className={'lz-static ' + (compact ? 'lz-compact ' : '') + (className ? className : '')}
                        style={style || {}}>{value}</p>
                    :
                    <p className={'lz-static ' + (compact ? 'lz-compact ' : '') + (className ? className : '')}
                        style={style || {}} dangerouslySetInnerHTML={{ __html: value }}
                    ></p>
                }

            </LzFormFieldBase>
        );
    }

}

export default LzFormFieldStatic;
